import {PlayerColor} from '../PlayerState'

// CornerVariables: https://prntscr.com/w5qvpk
export enum TileCornerDirection {
    North = 0,
    South = 1,
}

export enum TileCornerBuildingType {
    Settlement = 1,
    City = 2,
    DestroyedCity = 3,
    KnightActiveLevel1 = 4,
    KnightActiveLevel2 = 5,
    KnightActiveLevel3 = 6,
    KnightInactiveLevel1 = 7,
    KnightInactiveLevel2 = 8,
    KnightInactiveLevel3 = 9,
}

export enum TileCornerBonusType {
    IslandSettlingChits = 0,
    CityWall = 1,
    MetropolisScience = 2,
    MetropolisTrade = 3,
    MetropolisPolitics = 4,
}

export interface TileCornerState {
    readonly x: number
    readonly y: number
    readonly z: TileCornerDirection
    owner?: Exclude<PlayerColor, PlayerColor.None>
    buildingType?: TileCornerBuildingType
    bonuses?: TileCornerBonusType[]
    restrictedStartingPlacement?: true
}
